// src/utils/encrypt.js
import CryptoJS from "crypto-js";

/**
 * Helper: get key from env (fallback for dev only)
 */
const SECRET = process.env.REACT_APP_ENCRYPTION_KEY || "dev-secret-key-change-this";

/**
 * Make URL-safe base64 string (remove padding, replace +/)
 */
function toUrlSafeBase64(b64) {
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/**
 * Reverse URL-safe base64 to normal base64
 */
function fromUrlSafeBase64(urlSafe) {
  // add padding back if needed
  let b64 = urlSafe.replace(/-/g, "+").replace(/_/g, "/");
  const pad = b64.length % 4;
  if (pad === 2) b64 += "==";
  else if (pad === 3) b64 += "=";
  else if (pad === 1) b64 += "===";
  return b64;
}

/**
 * encodeId / encryptId
 * @param {string|number} id
 * @returns {string} url-safe encrypted token
 */
export function encodeId(id) {
  if (id === undefined || id === null) return "";
  const plain = String(id);

  // use AES encryption
  const ciphertext = CryptoJS.AES.encrypt(plain, SECRET).toString(); // base64
  return toUrlSafeBase64(ciphertext);
}

/**
 * decodeId / decryptId
 * @param {string} token - url-safe encrypted token
 * @returns {string} decrypted id (string). Caller can parseInt if needed.
 */
export function decodeId(token) {
  if (!token) return null;
  try {
    const b64 = fromUrlSafeBase64(token);
    const bytes = CryptoJS.AES.decrypt(b64, SECRET);
    const original = bytes.toString(CryptoJS.enc.Utf8);
    return original || null;
  } catch (err) {
    // invalid token or decryption error
    return null;
  }
}

/**
 * Backwards-compatible aliases (your pages import encryptId/decryptId)
 */
export const encryptId = encodeId;
export const decryptId = decodeId;

/**
 * default export (optional)
 */
export default {
  encodeId,
  decodeId,
  encryptId,
  decryptId,
};
